<script setup>
import { onMounted, computed } from 'vue';
import CalendarChart from '../../library/components/CalendarChart.vue';
import Loading from '../../library/components/Loading.vue';
import { useInsightsStore } from './stores/insight';

const { labels } = window.DATAAGENT_ORDER_METABOX;
const { woocommerce_tips } = window.DATAAGENT_ORDER_METABOX.urls;
const { upgrade: upgrade_url, loading_gif } = window.DATAAGENT_PLUGIN.urls;
const { plugin_url } = window.DATAAGENT_PLUGIN.path;
const insightsStore = useInsightsStore();
const daily_revenue_customer = computed(() => insightsStore.insights?.daily_revenue_customer);

onMounted(async () => {
  const { insights } = window.DATAAGENT_ORDER_METABOX;
  const insightsStore = useInsightsStore();
  await insightsStore.setInsights(insights);
});
</script>

<template>
  <div class="dataagent-container">
    <div class="da:grid da:grid-cols-[1fr_auto] da:items-center da:gap-4 da:border da:border-gray-300 da:rounded-md da:p-2">
      <div class="da:flex da:items-center da:gap-2">
        <p class="da:text-sm da:text-gray-500">{{ labels.woocommerce_tips }}</p>
      </div>
      <div class="da:flex da:items-center">
        <a
          :href="woocommerce_tips"
          target="_blank"
          class="da:bg-primary-600 da:text-white da:px-4 da:py-2 da:rounded-md da:flex da:items-center da:gap-2"
        >
          {{ labels.get_tips }}
          <i class="fas fa-external-link-alt"></i>
        </a>
      </div>
    </div>

    <div>
      <div class="da:flex da:items-center da:justify-between da:mb-4">
        <h3 class="da:text-gray-500 da:text-xl da:font-semibold">{{ labels.daily_revenue_customer }}</h3>
        <div class="da:flex da:items-center da:gap-x-2">
          <!-- Upgrade/Setting -->
          <div v-if="!premium" class="da:flex da:items-center da:gap-x-1">
            <a
              :href="upgrade_url"
              class="da:text-xs da:px-4 da:py-2 da:rounded-md da:border da:border-black"
              :title="labels.missing_data.tooltip"
            >
              {{ labels.missing_data.title }} ?
            </a>
          </div>
        </div>
      </div>

      <Loading v-if="!daily_revenue_customer" :labels="labels" :loading_gif="loading_gif" />
      <div
        v-else-if="daily_revenue_customer && daily_revenue_customer.length === 0"
        class="da:text-gray-400 da:text-sm da:text-center"
      >
        {{ labels.no_data }}
      </div>
      <CalendarChart
        v-else
        v-for="chart in insightsStore.daily_revenue_customer_calendar_chart"
        :key="chart.year"
        :config="chart"
      />
    </div>

    <Templates :labels="labels" :templates="templates" />
  </div>
</template>
